// // GREY AND WITHOUT UPPER DOTS
// const BASE_ICON = `
// <svg xmlns="http://www.w3.org/2000/svg" width="156.365" height="250.183" viewBox="0 0 156.365 250.183">
//   <style>
//     .body {
//       fill: black;
//     }

//     .body-circle {
//       fill: black;
//     }
//   </style>
//   <path id="Icon_metro-location" class="body" data-name="Icon metro-location" d="M56.241,81.7c0-17.072,13.564-30.911,30.3-30.911s30.3,13.84,30.3,30.911-13.564,30.911-30.3,30.911S56.241,98.771,56.241,81.7Z" transform="translate(-8.355 -5.013)"/>
//   <path id="Icon_metro-location-2" class="body-circle" data-name="Icon metro-location" d="M86.537,1.928A78.182,78.182,0,0,0,8.355,80.11c0,78.182,78.182,172,78.182,172s78.182-93.819,78.182-172A78.179,78.179,0,0,0,86.537,1.928Zm0,126.069A47.887,47.887,0,1,1,134.424,80.11,47.887,47.887,0,0,1,86.537,128Z" transform="translate(-8.355 -1.928)"/>
// </svg>
// `
// const BASE_ICON_WITH_CIRCLE = `
// <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.66 25.026">
//   <g id="Group_50" data-name="Group 50" transform="translate(70.64 -113.824)">
//     <path id="Subtraction_4" data-name="Subtraction 4" d="M7.765-930h0a46.755,46.755,0,0,1-3.882-5.629C2.111-938.64,0-943.072,0-947.083a7.774,7.774,0,0,1,7.765-7.765,7.689,7.689,0,0,1,3.438.8A3.993,3.993,0,0,0,10.64-952a3.993,3.993,0,0,0,.217,1.3,4.757,4.757,0,0,0-3.092-1.141,4.761,4.761,0,0,0-4.757,4.756,4.762,4.762,0,0,0,4.757,4.756,4.762,4.762,0,0,0,4.756-4.756,4.732,4.732,0,0,0-.335-1.757A3.96,3.96,0,0,0,14.64-948a4.03,4.03,0,0,0,.826-.086,7.868,7.868,0,0,1,.064,1c0,4.012-2.111,8.443-3.883,11.455A46.751,46.751,0,0,1,7.766-930Z" transform="translate(-70.64 1068.849)" fill="#707070"/>
//   </g>
//   <path id="Ellipse_118-2" data-name="Ellipse 118" d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z" transform="translate(4.765 4.9)" fill="#707070"/>
//   <circle id="Ellipse_118" data-name="Ellipse 118" cx="3" cy="3" r="3" transform="translate(11.66)" fill="#707070"/>
// </svg>
// `

// const BASE_CIRCLE = `<circle id="Ellipse_118" data-name="Ellipse 118" cx="3" cy="3" r="3" transform="translate(11.66)" fill="#707070"/>`

// const BASE_ICON_WITH_TWO_CIRCLE = `
// <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.66 25.026">
//   <g id="Group_50" data-name="Group 50" transform="translate(70.64 -113.824)">
//     <path id="Subtraction_4" data-name="Subtraction 4" d="M7.765-930h0a46.755,46.755,0,0,1-3.882-5.629C2.111-938.64,0-943.072,0-947.083a7.774,7.774,0,0,1,7.765-7.765,7.689,7.689,0,0,1,3.438.8A3.993,3.993,0,0,0,10.64-952a3.993,3.993,0,0,0,.217,1.3,4.757,4.757,0,0,0-3.092-1.141,4.761,4.761,0,0,0-4.757,4.756,4.762,4.762,0,0,0,4.757,4.756,4.762,4.762,0,0,0,4.756-4.756,4.732,4.732,0,0,0-.335-1.757A3.96,3.96,0,0,0,14.64-948a4.03,4.03,0,0,0,.826-.086,7.868,7.868,0,0,1,.064,1c0,4.012-2.111,8.443-3.883,11.455A46.751,46.751,0,0,1,7.766-930Z" transform="translate(-70.64 1068.849)" fill="#707070"/>
//   </g>
//   <path id="Ellipse_118-2" data-name="Ellipse 118" d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z" transform="translate(4.765 4.9)" fill="#707070"/>
//   <circle id="Ellipse_118" data-name="Ellipse 118" cx="3" cy="3" r="3" transform="translate(11.66)" fill="#707070"/>
//   <circle id="Ellipse_118" data-name="Ellipse 118" cx="3" cy="3" r="3" transform="translate(18.66)" fill="#707070"/>

// </svg>
// `

// const FACTOR = 7
// const BASE_TRANSLATE = 11.66

// const NOT_MONITORED = '#747474'
// const NOT_WORKING_MU_COLOR = '#810000'
// const WORKING_MU_COLOR = '#01754F'
// const MU_WORKING_PROJECT_NOT_WORKING = '#EB6841'

// export const MONITORING_STATUS_OBJECTS = [
//   {
//     title: 'Monitoring Working',
//     color: WORKING_MU_COLOR
//   },
//   {
//     title: 'Monitoring With Project Issue',
//     color: MU_WORKING_PROJECT_NOT_WORKING
//   },
//   {
//     title: 'Monitoring Not Working',
//     color: NOT_WORKING_MU_COLOR
//   },
//   {
//     title: 'Not Monitored',
//     color: NOT_MONITORED
//   }
// ]

// // Filter an array of markers
// export const filterMarkers = (
//   markersDB,
//   filterBy,
//   shouldCheckProject = true
// ) => {
//   let markersForMap = JSON.parse(JSON.stringify(markersDB))
//   let currFilter = JSON.parse(JSON.stringify(filterBy))
//   let filteredMarkers = markersForMap.filter((marker) => {
//     let include = true

//     if (currFilter.projectStage?.length) {
//       include = currFilter.projectStage.includes(marker.stage.id)
//     }
//     if (include && currFilter.projectType?.length) {
//       include = currFilter.projectType.includes(marker.type.id)
//     }

//     if (include && currFilter.projectCountry?.length) {
//       include = currFilter.projectCountry.includes(marker.country.id)
//     }

//     if (include && currFilter.projectDistrict?.length) {
//       include = currFilter.projectDistrict.includes(marker.district_id)
//     }

//     if (include && currFilter.projectZone?.length) {
//       if (marker.zone === null) {
//         include = false;
//       } else {
//         include = currFilter.projectZone.some(zonePart =>
//           marker.zone.toLowerCase().includes(zonePart.toLowerCase())
//         );
//       }
//     }

//     if (include && currFilter.projectPhase?.length) {
//       include = currFilter.projectPhase.includes(marker.phase.id)
//     }

//     if (shouldCheckProject && include && currFilter.projectId?.length) {
//       include = currFilter.projectId.includes(marker.id)
//     }

//     if (include && currFilter.projectDonor?.length) {
//       let includeDonor = false
//       for (let i = 0; i < marker?.donor?.length; i++) {
//         if (currFilter.projectDonor.includes(marker.donor[i].id)) {
//           includeDonor = true
//           break
//         }
//       }
//       include = includeDonor
//     }

//     if (include && currFilter.projectMonitored !== 'All') {
//       let monitor = currFilter.projectMonitored === 'Yes' ? true : false
//       include = monitor === marker.monitored
//     }

//     if (
//       include &&
//       currFilter.projectMonitored === 'Yes' &&
//       currFilter.projectMuStatus?.length
//     ) {
//       include = currFilter.projectMuStatus.includes(
//         marker.projectMonitoringStatus
//       )
//     }

//     // if (include && currFilter.projectProblem?.length) {
//     //   include = marker.problems.some((problem) =>
//     //     currFilter.projectProblem.includes(problem)
//     //   )
//     // }

//     if (include === true) {
//       return marker
//     }
//   })

//   return filteredMarkers
// }

// export const filterMarkerForIcon = (marker, filterBy) => {
//   let currMarker = JSON.parse(JSON.stringify(marker))
//   let currFilter = JSON.parse(JSON.stringify(filterBy))

//   let include = true
//   let gotIn = false

//   if (currFilter.projectStage?.length) {
//     gotIn = true
//     include = currFilter.projectStage.includes(currMarker.stage.id)
//   }

//   if (include && currFilter.projectType?.length) {
//     gotIn = true
//     include = currFilter.projectType.includes(currMarker.type.id)
//   }

//   if (include && currFilter.projectCountry?.length) {
//     gotIn = true
//     include = currFilter.projectCountry.includes(currMarker.country.id)
//   }

//   if (include && currFilter.projectDistrict?.length) {
//     include = currFilter.projectDistrict.includes(currMarker.district_id)
//   }

//   if (include && currFilter.projectPhase?.length) {
//     gotIn = true
//     include = currFilter.projectPhase.includes(currMarker.phase.id)
//   }

//   if (include && currFilter.projectDonor?.length) {
//     gotIn = true
//     let includeDonor = false
//     for (let i = 0; i < currMarker?.donor?.length; i++) {
//       if (currFilter.projectDonor.includes(currMarker.donor[i].id)) {
//         includeDonor = true
//         break
//       }
//     }
//     include = includeDonor
//   }

//   if (include && currFilter.projectMonitored !== 'All') {
//     gotIn = true
//     let monitor = currFilter.projectMonitored === 'Yes' ? true : false
//     include = monitor === currMarker.monitored
//   }

//   if (
//     include &&
//     currFilter.projectMonitored === 'Yes' &&
//     currFilter.projectMuStatus?.length
//   ) {
//     include = currFilter.projectMuStatus.includes(
//       currMarker.projectMonitoringStatus
//     )
//   }

//   if (!gotIn) return !gotIn
//   return include
// }
// // check if user is allowed to add another filter
// export const checkFilter = (filter) => {
//   if (
//     filter.projectStage?.length ||
//     filter.projectCountry?.length ||
//     filter.projectDistrict?.length ||
//     filter.projectZone?.length ||
//     filter.projectId?.length ||
//     filter.projectDonor?.length ||
//     filter.projectType?.length ||
//     filter.projectPhase?.length ||
//     filter.projectMonitored !== 'All' ||
//     filter.projectMuStatus?.length ||
//     filter.projectProblem?.length
//   ) {
//     return true
//   } else {
//     return false
//   }
// }

// export const removeDuplicatesObjects = (arr) => {
//   const seen = new Set()
//   return arr.filter((obj) => {
//     return !seen.has(obj.id) && seen.add(obj.id)
//   })
// }

// export const checkIfProblemStillPossible = (markers, problems) => {
//   let markersProblems = markers.map((marker) => {
//     if (marker.problems) {
//       if (marker.problems.length > 0) {
//         return marker.problems
//       }
//     }
//     return false
//   })
//   const flatArr = markersProblems.flat()

//   return [
//     ...new Set(flatArr.filter((problem) => problems.includes(problem)).sort())
//   ]
// }

// export const organizeProjectTypes = (projectTypes) => {
//   return projectTypes.map((projectType) => {
//     return {
//       id: projectType.id,
//       name: projectType.name,
//       icon: projectType.marker_icon,
//       color: projectType.color
//     }
//   })
// }

// export const organizeProjects = (
//   projects,
//   countries,
//   projectStages,
//   projectTypes,
//   projectPhases,
//   donorsArr,
//   allReminders,
//   ProjectsMonitoringStatus
// ) => {
//   return projects.map((project) => {
//     let reminders = allReminders
//       .filter((reminder) => reminder.project_id === project.id)
//       ?.map((reminder) => reminder?.name)

//     let donors = getDonors(project.donors_id, donorsArr)
//     let projectStage = projectStages?.length
//       ? projectStages.find((stage) => stage.id === project.project_stage_id)
//       : null
//     let projectType =
//       projectTypes.find((type) => type.id === project.project_type_id) || null
//     let projectCountry =
//       countries.find((country) => country.id === project.country_id) || null

//     let projectPhase =
//       projectPhases.find((phase) => phase.id === project.project_phase_id) ||
//       null
//     let coloredSvgString = `<svg xmlns="http://www.w3.org/2000/svg" width="15.53" height="24.85" viewBox="0 0 15.53 24.85">
//       <defs>
//         <style>
//           .cls-1 {
//             fill: ${projectType.color};
//           }

//           .cls-2 {
//             fill: #01754F;
//           }
//         </style>
//       </defs>
// <path class="cls-1" id="Icon_metro-location" data-name="Icon metro-location" d="M16.12,1.928A7.765,7.765,0,0,0,8.355,9.694c0,7.766,7.765,17.084,7.765,17.084s7.765-9.319,7.765-17.084A7.765,7.765,0,0,0,16.12,1.928Zm0,12.522a4.756,4.756,0,1,1,4.756-4.756A4.756,4.756,0,0,1,16.12,14.45Z" transform="translate(-8.355 -1.928)"/>
// <path class="cls-2" id="Ellipse_118" data-name="Ellipse 118" d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z" transform="translate(4.765 4.725)"/>
// </svg>
// `

//     let projectMonitoringStatus = null
//     if (project.monitored) {
//       projectMonitoringStatus = ProjectsMonitoringStatus.find(
//         (p) => p.id === project.id
//       )?.monitoring_issue_root_cause
//       if (projectMonitoringStatus === 'Monitoring') {
//         // Monitoring is not working
//         coloredSvgString = coloredSvgString.replace(
//           '#01754F',
//           NOT_WORKING_MU_COLOR
//         )
//       } else if (projectMonitoringStatus === 'Project') {
//         // Monitoring is working but project is not working
//         coloredSvgString = coloredSvgString.replace(
//           '#01754F',
//           MU_WORKING_PROJECT_NOT_WORKING
//         )
//       } else {
//         // Monitoring is working
//         projectMonitoringStatus = 'Working'
//       }
//     } else {
//       coloredSvgString = coloredSvgString.replace('#01754F', NOT_MONITORED)
//     }

//     return {
//       id: project.id,
//       name: project.name,
//       country: {
//         id: projectCountry.id,
//         name: projectCountry.name
//       },
//       position: {
//         lng: parseFloat(project.longitude),
//         lat: parseFloat(project.latitude)
//       },
//       stage: projectStage,
//       type: projectType,
//       phase: projectPhase,
//       donor: donors,
//       monitored: project.monitored,
//       micro_view_link: project.micro_view,
//       donor_page_link: project.donor_page,
//       coloredSvgString,
//       reminders: reminders || [],
//       projectMonitoringStatus,
//       district_id: project.district_id || null,
//       zone: project.zone || null
//     }
//   })
// }

// export const createMarkerIcon = (marker, selectedGroups) => {
//   let insideCircleColor = NOT_MONITORED
//   if (marker.monitored) {
//     if (marker.projectMonitoringStatus === 'Monitoring') {
//       insideCircleColor = NOT_WORKING_MU_COLOR
//     } else if (marker.projectMonitoringStatus === 'Project') {
//       insideCircleColor = MU_WORKING_PROJECT_NOT_WORKING
//     } else {
//       insideCircleColor = WORKING_MU_COLOR
//     }
//   }
//   let stringArrayToAdd = []
//   selectedGroups.forEach((group) => {
//     let include = marker.reminders.includes(group.name)
//     if (include) {
//       let circleString = getCircle(group.color, stringArrayToAdd.length)
//       stringArrayToAdd.push(circleString)
//     }
//   })

//   let viewBoxWidth =
//     stringArrayToAdd.length > 0 ? 16 + FACTOR * stringArrayToAdd.length : 16
//   let viewBoxHeight =
//     stringArrayToAdd.length > 0 ? 21 + FACTOR * stringArrayToAdd.length : 21
//   let baseIcon = `
//   <svg xmlns="http://www.w3.org/2000/svg" width="${viewBoxWidth}" height="${viewBoxHeight}" viewBox="0 0 ${viewBoxWidth} ${viewBoxHeight}">
//     <g id="Group_50" data-name="Group 50" transform="translate(70.64 -113.824)">
//       <path id="Subtraction_4" data-name="Subtraction 4" d="M7.765-930h0a46.755,46.755,0,0,1-3.882-5.629C2.111-938.64,0-943.072,0-947.083a7.774,7.774,0,0,1,7.765-7.765,7.689,7.689,0,0,1,3.438.8A3.993,3.993,0,0,0,10.64-952a3.993,3.993,0,0,0,.217,1.3,4.757,4.757,0,0,0-3.092-1.141,4.761,4.761,0,0,0-4.757,4.756,4.762,4.762,0,0,0,4.757,4.756,4.762,4.762,0,0,0,4.756-4.756,4.732,4.732,0,0,0-.335-1.757A3.96,3.96,0,0,0,14.64-948a4.03,4.03,0,0,0,.826-.086,7.868,7.868,0,0,1,.064,1c0,4.012-2.111,8.443-3.883,11.455A46.751,46.751,0,0,1,7.766-930Z" transform="translate(-70.64 1068.849)" fill="${marker.type.color}"/>
//     </g>
//     <path id="Ellipse_118-2" data-name="Ellipse 118" d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z" transform="translate(4.765 4.9)" fill="${insideCircleColor}"/>
//     `

//   if (stringArrayToAdd.length > 0) {
//     let stringToAdd = stringArrayToAdd.join(' ')
//     baseIcon += stringToAdd
//   } else {
//     return {
//       url: `data:image/svg+xml;base64,${window.btoa(marker.coloredSvgString)}`,
//       scaledSize: { width: 16, height: 21 }
//     }
//   }
//   baseIcon += `</svg>`
//   return {
//     url: `data:image/svg+xml;base64,${window.btoa(baseIcon)}`,
//     scaledSize: { width: viewBoxWidth, height: viewBoxHeight }
//   }
// }

// export const generateRandomID = () => {
//   return Math.random().toString(36).substr(2, 9)
// }

// function getDonors(projectDonors, donorsArr) {
//   return donorsArr.filter((donor) => projectDonors.includes(donor.id))
// }

// function getCircle(color, translateIndex = 1) {
//   let translate = translateIndex * FACTOR + BASE_TRANSLATE
//   return `<circle id="Ellipse_118" data-name="Ellipse 118" cx="3" cy="3" r="3" transform="translate(${translate})" fill="${color}"/>`
// }

// GREY AND WITHOUT UPPER DOTS
const BASE_ICON = `
<svg xmlns="http://www.w3.org/2000/svg" width="156.365" height="250.183" viewBox="0 0 156.365 250.183">
  <style>
    .body {
      fill: black;
    }

    .body-circle {
      fill: black;
    }
  </style>
  <path id="Icon_metro-location" class="body" data-name="Icon metro-location" d="M56.241,81.7c0-17.072,13.564-30.911,30.3-30.911s30.3,13.84,30.3,30.911-13.564,30.911-30.3,30.911S56.241,98.771,56.241,81.7Z" transform="translate(-8.355 -5.013)"/>
  <path id="Icon_metro-location-2" class="body-circle" data-name="Icon metro-location" d="M86.537,1.928A78.182,78.182,0,0,0,8.355,80.11c0,78.182,78.182,172,78.182,172s78.182-93.819,78.182-172A78.179,78.179,0,0,0,86.537,1.928Zm0,126.069A47.887,47.887,0,1,1,134.424,80.11,47.887,47.887,0,0,1,86.537,128Z" transform="translate(-8.355 -1.928)"/>
</svg>
`
const BASE_ICON_WITH_CIRCLE = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.66 25.026">
  <g id="Group_50" data-name="Group 50" transform="translate(70.64 -113.824)">
    <path id="Subtraction_4" data-name="Subtraction 4" d="M7.765-930h0a46.755,46.755,0,0,1-3.882-5.629C2.111-938.64,0-943.072,0-947.083a7.774,7.774,0,0,1,7.765-7.765,7.689,7.689,0,0,1,3.438.8A3.993,3.993,0,0,0,10.64-952a3.993,3.993,0,0,0,.217,1.3,4.757,4.757,0,0,0-3.092-1.141,4.761,4.761,0,0,0-4.757,4.756,4.762,4.762,0,0,0,4.757,4.756,4.762,4.762,0,0,0,4.756-4.756,4.732,4.732,0,0,0-.335-1.757A3.96,3.96,0,0,0,14.64-948a4.03,4.03,0,0,0,.826-.086,7.868,7.868,0,0,1,.064,1c0,4.012-2.111,8.443-3.883,11.455A46.751,46.751,0,0,1,7.766-930Z" transform="translate(-70.64 1068.849)" fill="#707070"/>
  </g>
  <path id="Ellipse_118-2" data-name="Ellipse 118" d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z" transform="translate(4.765 4.9)" fill="#707070"/>
  <circle id="Ellipse_118" data-name="Ellipse 118" cx="3" cy="3" r="3" transform="translate(11.66)" fill="#707070"/>
</svg>
`

const BASE_CIRCLE = `<circle id="Ellipse_118" data-name="Ellipse 118" cx="3" cy="3" r="3" transform="translate(11.66)" fill="#707070"/>`

const BASE_ICON_WITH_TWO_CIRCLE = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.66 25.026">
  <g id="Group_50" data-name="Group 50" transform="translate(70.64 -113.824)">
    <path id="Subtraction_4" data-name="Subtraction 4" d="M7.765-930h0a46.755,46.755,0,0,1-3.882-5.629C2.111-938.64,0-943.072,0-947.083a7.774,7.774,0,0,1,7.765-7.765,7.689,7.689,0,0,1,3.438.8A3.993,3.993,0,0,0,10.64-952a3.993,3.993,0,0,0,.217,1.3,4.757,4.757,0,0,0-3.092-1.141,4.761,4.761,0,0,0-4.757,4.756,4.762,4.762,0,0,0,4.757,4.756,4.762,4.762,0,0,0,4.756-4.756,4.732,4.732,0,0,0-.335-1.757A3.96,3.96,0,0,0,14.64-948a4.03,4.03,0,0,0,.826-.086,7.868,7.868,0,0,1,.064,1c0,4.012-2.111,8.443-3.883,11.455A46.751,46.751,0,0,1,7.766-930Z" transform="translate(-70.64 1068.849)" fill="#707070"/>
  </g>
  <path id="Ellipse_118-2" data-name="Ellipse 118" d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z" transform="translate(4.765 4.9)" fill="#707070"/>
  <circle id="Ellipse_118" data-name="Ellipse 118" cx="3" cy="3" r="3" transform="translate(11.66)" fill="#707070"/>
  <circle id="Ellipse_118" data-name="Ellipse 118" cx="3" cy="3" r="3" transform="translate(18.66)" fill="#707070"/>

</svg>
`

const FACTOR = 7
const BASE_TRANSLATE = 11.66

const NOT_MONITORED = '#747474'
const NOT_WORKING_MU_COLOR = '#810000'
const WORKING_MU_COLOR = '#01754F'
const MU_WORKING_PROJECT_NOT_WORKING = '#EB6841'

export const MONITORING_STATUS_OBJECTS = [
  {
    title: 'Monitoring Working',
    color: WORKING_MU_COLOR
  },
  {
    title: 'Monitoring With Project Issue',
    color: MU_WORKING_PROJECT_NOT_WORKING
  },
  {
    title: 'Monitoring Not Working',
    color: NOT_WORKING_MU_COLOR
  },
  {
    title: 'Not Monitored',
    color: NOT_MONITORED
  }
]

// Filter an array of markers
export const filterMarkers = (
  markersDB,
  filterBy,
  shouldCheckProject = true
) => {
  let markersForMap = JSON.parse(JSON.stringify(markersDB))
  let currFilter = JSON.parse(JSON.stringify(filterBy))
  let filteredMarkers = markersForMap.filter((marker) => {
    let include = true

    if (currFilter.projectStage?.length) {
      include = currFilter.projectStage.includes(marker.stage.id)
    }
    if (include && currFilter.projectType?.length) {
      include = currFilter.projectType.includes(marker.type.id)
    }

    if (include && currFilter.projectCountry?.length) {
      include = currFilter.projectCountry.includes(marker.country.id)
    }

    if (include && currFilter.projectDistrict?.length) {
      include = currFilter.projectDistrict.includes(marker.district_id)
    }

    if (include && currFilter.projectZone?.length) {
      if (marker.zone === null) {
        include = false
      } else {
        include = currFilter.projectZone.some((zonePart) =>
          marker.zone.toLowerCase().includes(zonePart.toLowerCase())
        )
      }
    }

    if (include && currFilter.projectPhase?.length) {
      include = currFilter.projectPhase.includes(marker.phase.id)
    }

    if (shouldCheckProject && include && currFilter.projectId?.length) {
      include = currFilter.projectId.includes(marker.id)
    }

    if (include && currFilter.projectDonor?.length) {
      let includeDonor = false
      for (let i = 0; i < marker?.donor?.length; i++) {
        if (currFilter.projectDonor.includes(marker.donor[i].id)) {
          includeDonor = true
          break
        }
      }
      include = includeDonor
    }

    if (include && currFilter.projectMonitored !== 'All') {
      let monitor = currFilter.projectMonitored === 'Yes' ? true : false
      include = monitor === marker.monitored
    }

    if (
      include &&
      currFilter.projectMonitored === 'Yes' &&
      currFilter.projectMuStatus?.length
    ) {
      include = currFilter.projectMuStatus.includes(
        marker.projectMonitoringStatus
      )
    }
    // if (include && currFilter.projectProblem?.length) {
    //   include = marker.problems.some((problem) =>
    //     currFilter.projectProblem.includes(problem)
    //   )
    // }

    if (include === true) {
      return marker
    }
  })

  return filteredMarkers
}

export const filterMarkerForIcon = (marker, filterBy) => {
  let currMarker = JSON.parse(JSON.stringify(marker))
  let currFilter = JSON.parse(JSON.stringify(filterBy))

  let include = true
  let gotIn = false

  if (currFilter.projectStage?.length) {
    gotIn = true
    include = currFilter.projectStage.includes(currMarker.stage.id)
  }

  if (include && currFilter.projectType?.length) {
    gotIn = true
    include = currFilter.projectType.includes(currMarker.type.id)
  }

  if (include && currFilter.projectCountry?.length) {
    gotIn = true
    include = currFilter.projectCountry.includes(currMarker.country.id)
  }

  if (include && currFilter.projectDistrict?.length) {
    include = currFilter.projectDistrict.includes(currMarker.district_id)
  }

  if (include && currFilter.projectPhase?.length) {
    gotIn = true
    include = currFilter.projectPhase.includes(currMarker.phase.id)
  }

  if (include && currFilter.projectDonor?.length) {
    gotIn = true
    let includeDonor = false
    for (let i = 0; i < currMarker?.donor?.length; i++) {
      if (currFilter.projectDonor.includes(currMarker.donor[i].id)) {
        includeDonor = true
        break
      }
    }
    include = includeDonor
  }

  if (include && currFilter.projectMonitored !== 'All') {
    gotIn = true
    let monitor = currFilter.projectMonitored === 'Yes' ? true : false
    include = monitor === currMarker.monitored
  }

  if (
    include &&
    currFilter.projectMonitored === 'Yes' &&
    currFilter.projectMuStatus?.length
  ) {
    include = currFilter.projectMuStatus.includes(
      currMarker.projectMonitoringStatus
    )
  }

  if (!gotIn) return !gotIn
  return include
}
// check if user is allowed to add another filter
export const checkFilter = (filter) => {
  if (
    filter.projectStage?.length ||
    filter.projectCountry?.length ||
    filter.projectDistrict?.length ||
    filter.projectZone?.length ||
    filter.projectId?.length ||
    filter.projectDonor?.length ||
    filter.projectType?.length ||
    filter.projectPhase?.length ||
    filter.projectMonitored !== 'All' ||
    filter.projectMuStatus?.length ||
    filter.projectProblem?.length
  ) {
    return true
  } else {
    return false
  }
}

export const removeDuplicatesObjects = (arr) => {
  const seen = new Set()
  return arr.filter((obj) => {
    return !seen.has(obj.id) && seen.add(obj.id)
  })
}

export const checkIfProblemStillPossible = (markers, problems) => {
  let markersProblems = markers.map((marker) => {
    if (marker.problems) {
      if (marker.problems.length > 0) {
        return marker.problems
      }
    }
    return false
  })
  const flatArr = markersProblems.flat()

  return [
    ...new Set(flatArr.filter((problem) => problems.includes(problem)).sort())
  ]
}

export const organizeProjectTypes = (projectTypes) => {
  return projectTypes.map((projectType) => {
    return {
      id: projectType.id,
      name: projectType.name,
      icon: projectType.marker_icon,
      color: projectType.color
    }
  })
}

export const organizeProjects = (
  projects,
  countries,
  projectStages,
  projectTypes,
  projectPhases,
  donorsArr,
  allReminders,
  ProjectsMonitoringStatus
) => {
  return projects.map((project) => {
    let reminders = allReminders
      .filter((reminder) => reminder.project_id === project.id)
      ?.map((reminder) => reminder?.name)

    let donors = getDonors(project.donors_id, donorsArr)
    let projectStage = projectStages?.length
      ? projectStages.find((stage) => stage.id === project.project_stage_id)
      : null
    let projectType =
      projectTypes.find((type) => type.id === project.project_type_id) || null
    let projectCountry =
      countries.find((country) => country.id === project.country_id) || null

    let projectPhase =
      projectPhases.find((phase) => phase.id === project.project_phase_id) ||
      null
    let coloredSvgString = `<svg xmlns="http://www.w3.org/2000/svg" width="15.53" height="24.85" viewBox="0 0 15.53 24.85">
      <defs>
        <style>
          .cls-1 {
            fill: ${projectType.color};
          }

          .cls-2 {
            fill: #01754F;
          }
        </style>
      </defs>
<path class="cls-1" id="Icon_metro-location" data-name="Icon metro-location" d="M16.12,1.928A7.765,7.765,0,0,0,8.355,9.694c0,7.766,7.765,17.084,7.765,17.084s7.765-9.319,7.765-17.084A7.765,7.765,0,0,0,16.12,1.928Zm0,12.522a4.756,4.756,0,1,1,4.756-4.756A4.756,4.756,0,0,1,16.12,14.45Z" transform="translate(-8.355 -1.928)"/>
<path class="cls-2" id="Ellipse_118" data-name="Ellipse 118" d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z" transform="translate(4.765 4.725)"/>
</svg>
`

    let projectMonitoringStatus = null
    if (project.monitored) {
      projectMonitoringStatus = ProjectsMonitoringStatus.find(
        (p) => p.id === project.id
      )?.monitoring_issue_root_cause
      if (projectMonitoringStatus === 'Monitoring') {
        // Monitoring is not working
        coloredSvgString = coloredSvgString.replace(
          '#01754F',
          NOT_WORKING_MU_COLOR
        )
      } else if (projectMonitoringStatus === 'Project') {
        // Monitoring is working but project is not working
        coloredSvgString = coloredSvgString.replace(
          '#01754F',
          MU_WORKING_PROJECT_NOT_WORKING
        )
      } else {
        // Monitoring is working
        projectMonitoringStatus = 'Working'
      }
    } else {
      coloredSvgString = coloredSvgString.replace('#01754F', NOT_MONITORED)
    }

    return {
      id: project.id,
      name: project.name,
      country: {
        id: projectCountry.id,
        name: projectCountry.name
      },
      position: {
        lng: parseFloat(project.longitude),
        lat: parseFloat(project.latitude)
      },
      stage: projectStage,
      type: projectType,
      phase: projectPhase,
      donor: donors,
      monitored: project.monitored,
      micro_view_link: project.micro_view,
      donor_page_link: project.donor_page,
      coloredSvgString,
      reminders: reminders || [],
      projectMonitoringStatus,
      district_id: project.district_id || null,
      zone: project.zone || null
    }
  })
}

// export const createMarkerIcon = (marker, selectedGroups) => {
//   let insideCircleColor = NOT_MONITORED
//   if (marker.monitored) {
//     if (marker.projectMonitoringStatus === 'Monitoring') {
//       insideCircleColor = NOT_WORKING_MU_COLOR
//     } else if (marker.projectMonitoringStatus === 'Project') {
//       insideCircleColor = MU_WORKING_PROJECT_NOT_WORKING
//     } else {
//       insideCircleColor = WORKING_MU_COLOR
//     }
//   }
//   let stringArrayToAdd = []
//   selectedGroups.forEach((group) => {
//     let include = marker.reminders.includes(group.name)
//     if (include) {
//       let circleString = getCircle(group.color, stringArrayToAdd.length)
//       stringArrayToAdd.push(circleString)
//     }
//   })

//   let viewBoxWidth =
//     stringArrayToAdd.length > 0 ? 16 + FACTOR * stringArrayToAdd.length : 16
//   let viewBoxHeight =
//     stringArrayToAdd.length > 0 ? 21 + FACTOR * stringArrayToAdd.length : 21
//   let baseIcon = `
//   <svg xmlns="http://www.w3.org/2000/svg" width="${viewBoxWidth}" height="${viewBoxHeight}" viewBox="0 0 ${viewBoxWidth} ${viewBoxHeight}">
//     <g id="Group_50" data-name="Group 50" transform="translate(70.64 -113.824)">
//       <path id="Subtraction_4" data-name="Subtraction 4" d="M7.765-930h0a46.755,46.755,0,0,1-3.882-5.629C2.111-938.64,0-943.072,0-947.083a7.774,7.774,0,0,1,7.765-7.765,7.689,7.689,0,0,1,3.438.8A3.993,3.993,0,0,0,10.64-952a3.993,3.993,0,0,0,.217,1.3,4.757,4.757,0,0,0-3.092-1.141,4.761,4.761,0,0,0-4.757,4.756,4.762,4.762,0,0,0,4.757,4.756,4.762,4.762,0,0,0,4.756-4.756,4.732,4.732,0,0,0-.335-1.757A3.96,3.96,0,0,0,14.64-948a4.03,4.03,0,0,0,.826-.086,7.868,7.868,0,0,1,.064,1c0,4.012-2.111,8.443-3.883,11.455A46.751,46.751,0,0,1,7.766-930Z" transform="translate(-70.64 1068.849)" fill="${marker.type.color}"/>
//     </g>
//     <path id="Ellipse_118-2" data-name="Ellipse 118" d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z" transform="translate(4.765 4.9)" fill="${insideCircleColor}"/>
//     `

//   if (stringArrayToAdd.length > 0) {
//     let stringToAdd = stringArrayToAdd.join(' ')
//     baseIcon += stringToAdd
//   } else {
//     return {
//       url: `data:image/svg+xml;base64,${window.btoa(marker.coloredSvgString)}`,
//       scaledSize: { width: 16, height: 21 }
//     }
//   }
//   baseIcon += `</svg>`
//   return {
//     url: `data:image/svg+xml;base64,${window.btoa(baseIcon)}`,
//     scaledSize: { width: viewBoxWidth, height: viewBoxHeight }
//   }
// }

export const generateRandomID = () => {
  return Math.random().toString(36).substr(2, 9)
}

function getDonors(projectDonors, donorsArr) {
  return donorsArr.filter((donor) => projectDonors.includes(donor.id))
}

// Used in MainMap.vue
export const getProjects = (
  fetchedProjects,
  filtersOptions,
  ProjectsMonitoringStatus,
  AllReminders
) => {
  const projectTypes = filtersOptions.find(
    (item) => item.field === 'project_type_id'
  ).options

  const projects = fetchedProjects.map((project) => {
    let reminders = AllReminders ? AllReminders.filter(
      (reminder) => reminder.project_id === project.id
    )?.map((reminder) => reminder?.name) : []
    const projectType = projectTypes.find(
      (type) => type.id === project.project_type_id
    )
    let coloredSvgString = `<svg xmlns="http://www.w3.org/2000/svg" width="15.53" height="24.85" viewBox="0 0 15.53 24.85">
      <defs>
        <style>
          .cls-1 {
            fill: ${projectType.color};
          }

          .cls-2 {
            fill: #01754F;
          }
        </style>
      </defs>
      <path class="cls-1" id="Icon_metro-location" data-name="Icon metro-location" d="M16.12,1.928A7.765,7.765,0,0,0,8.355,9.694c0,7.766,7.765,17.084,7.765,17.084s7.765-9.319,7.765-17.084A7.765,7.765,0,0,0,16.12,1.928Zm0,12.522a4.756,4.756,0,1,1,4.756-4.756A4.756,4.756,0,0,1,16.12,14.45Z" transform="translate(-8.355 -1.928)"/>
      <path class="cls-2" id="Ellipse_118" data-name="Ellipse 118" d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z" transform="translate(4.765 4.725)"/>
    </svg>
    `
    let projectMonitoringStatus = null
    if (project.monitored) {
      projectMonitoringStatus = ProjectsMonitoringStatus.find(
        (p) => p.id === project.id
      )?.monitoring_issue_root_cause
      if (projectMonitoringStatus === 'Monitoring') {
        coloredSvgString = coloredSvgString.replace(
          '#01754F',
          NOT_WORKING_MU_COLOR
        )
      } else if (projectMonitoringStatus === 'Project') {
        coloredSvgString = coloredSvgString.replace(
          '#01754F',
          MU_WORKING_PROJECT_NOT_WORKING
        )
      } else {
        projectMonitoringStatus = 'Working'
      }
    } else {
      coloredSvgString = coloredSvgString.replace('#01754F', NOT_MONITORED)
    }

    return {
      ...project,
      latitude: parseFloat(project.latitude),
      longitude: parseFloat(project.longitude),
      monitored_string: project.monitored ? 'Yes' : 'No',
      project_monitoring_status: projectMonitoringStatus,
      coloredSvgString,
      reminders: reminders || []
    }
  })

  return projects
}
export const getFilteredProjects = (projects, filter) => {
  let filteredProjects = projects
  for (const key in filter) {
    if (key === 'filterName') continue
    if (Array.isArray(filter[key]) && filter[key].length > 0) {
      const projectKey = key === 'project_id' ? 'id' : key
      filteredProjects = filteredProjects.filter((project) => {
        if (Array.isArray(project[key])) {
          return filter[key].some((value) => project[key].includes(value))
        } else {
          return filter[key].includes(project[projectKey])
        }
      })
    } else if (typeof filter[key] === 'string') {
      if (filter[key] && filter[key] !== 'All') {
        filteredProjects = filteredProjects.filter(
          (project) => project[key] === filter[key]
        )
      }
    }
  }
  return filteredProjects
}
export const createMarkerIcon = (
  marker,
  selectedGroups,
  currentProjectType
) => {
  let insideCircleColor = NOT_MONITORED
  if (marker.monitored) {
    if (marker.projectMonitoringStatus === 'Monitoring') {
      insideCircleColor = NOT_WORKING_MU_COLOR
    } else if (marker.projectMonitoringStatus === 'Project') {
      insideCircleColor = MU_WORKING_PROJECT_NOT_WORKING
    } else {
      insideCircleColor = WORKING_MU_COLOR
    }
  }
  let stringArrayToAdd = []
  selectedGroups.forEach((group) => {
    let include = marker.reminders.includes(group.name)
    if (include) {
      let circleString = getCircle(group.color, stringArrayToAdd.length)
      stringArrayToAdd.push(circleString)
    }
  })

  let viewBoxWidth =
    stringArrayToAdd.length > 0 ? 16 + FACTOR * stringArrayToAdd.length : 16
  let viewBoxHeight =
    stringArrayToAdd.length > 0 ? 21 + FACTOR * stringArrayToAdd.length : 21
  let baseIcon = `
  <svg xmlns="http://www.w3.org/2000/svg" width="${viewBoxWidth}" height="${viewBoxHeight}" viewBox="0 0 ${viewBoxWidth} ${viewBoxHeight}">
    <g id="Group_50" data-name="Group 50" transform="translate(70.64 -113.824)">
      <path id="Subtraction_4" data-name="Subtraction 4" d="M7.765-930h0a46.755,46.755,0,0,1-3.882-5.629C2.111-938.64,0-943.072,0-947.083a7.774,7.774,0,0,1,7.765-7.765,7.689,7.689,0,0,1,3.438.8A3.993,3.993,0,0,0,10.64-952a3.993,3.993,0,0,0,.217,1.3,4.757,4.757,0,0,0-3.092-1.141,4.761,4.761,0,0,0-4.757,4.756,4.762,4.762,0,0,0,4.757,4.756,4.762,4.762,0,0,0,4.756-4.756,4.732,4.732,0,0,0-.335-1.757A3.96,3.96,0,0,0,14.64-948a4.03,4.03,0,0,0,.826-.086,7.868,7.868,0,0,1,.064,1c0,4.012-2.111,8.443-3.883,11.455A46.751,46.751,0,0,1,7.766-930Z" transform="translate(-70.64 1068.849)" fill="${currentProjectType.color}"/>
    </g>
    <path id="Ellipse_118-2" data-name="Ellipse 118" d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z" transform="translate(4.765 4.9)" fill="${insideCircleColor}"/>
    `

  if (stringArrayToAdd.length > 0) {
    let stringToAdd = stringArrayToAdd.join(' ')
    baseIcon += stringToAdd
  } else {
    return {
      url: `data:image/svg+xml;base64,${window.btoa(marker.coloredSvgString)}`,
      scaledSize: { width: 16, height: 21 }
    }
  }
  baseIcon += `</svg>`
  return {
    url: `data:image/svg+xml;base64,${window.btoa(baseIcon)}`,
    scaledSize: { width: viewBoxWidth, height: viewBoxHeight }
  }
}
function getCircle(color, translateIndex = 1) {
  let translate = translateIndex * FACTOR + BASE_TRANSLATE
  return `<circle id="Ellipse_118" data-name="Ellipse 118" cx="3" cy="3" r="3" transform="translate(${translate})" fill="${color}"/>`
}
